module.exports = __webpack_public_path__ + "img/allaria-blanco.7ad87ef8.png";